/**
 * Screens a wallet address using TRM (Transaction Risk Management) service
 * 
 * @param address - The wallet address to screen for risk assessment
 * @returns Promise<any> - The screening result from TRM API, or true if screening fails
 * 
 * @throws Will log a warning if the screening request fails
 * 
 * @example
 * ```typescript
 * const result = await TRM_screenAddress("0x1234567890123456789012345678901234567890");
 * ```
 */
export async function TRM_screenAddress(address: string) {
	try {
		if(address) {
			const response = await fetch(`/api/ident/tmr/screen?address=${address}`);
			if(!response.ok) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}
			const result = await response.json();
			return result;
		}
		throw new Error("invalid address received, not even truthy.");
	}
	catch(err) {
		console.warn(`TRM screening has failed - ${err instanceof Error ? err.message : "unknown error"}`);
		return true;
	}
}
